import { CircularProgress } from '@mui/material';

import classes from 'components/common/ReportFavoriteIcon/ReportFavoriteIcon.module.scss';
import { useSetReportFavoriteStatus } from 'components/common/ReportFavoriteIcon/hooks/setReportFavoriteStatus';

import { StarIcon } from '../Icons/common/StarIcon/StarIcon';

const ICON_SIZE = '30px';

interface Props {
    id: number;
    isFavorite: boolean;
    showLoader?: boolean;
}

export const ReportFavoriteIcon = ({ isFavorite, id, showLoader = false }: Props) => {
    const { updateFavorites, isUpdateFavoritesLoading } = useSetReportFavoriteStatus(id);
    return (
        <span className={classes.favoriteContainer}>
            <StarIcon
                isActive={isFavorite}
                className={isFavorite ? classes.favorite : classes.addToFavourites}
                onClick={async () => {
                    await updateFavorites(!isFavorite);
                }}
            />
            {showLoader && isUpdateFavoritesLoading && (
                <CircularProgress className={classes.loading} size={ICON_SIZE} />
            )}
        </span>
    );
};
